__webpack_require__.p = "/bizx-smart/max-imagin/";